var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 133,
    viewBox: "0 0 90 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84933 1.44046L35.0937 0.696059C37.2202 0.64613 38.9814 2.48897 39.0268 4.81522L40.6835 88.0223C40.7289 90.3486 42.49 92.1937 44.6166 92.1415L85.0456 91.1792C87.1722 91.1293 88.9333 92.9721 88.9787 95.2984L89.5869 125.86C89.6323 128.186 87.9461 130.113 85.8218 130.163L6.44791 132.053C4.32138 132.103 2.56025 130.26 2.51486 127.934L0.08195 5.74345C0.0365597 3.4172 1.7228 1.49039 3.84706 1.44046H3.84933Z",
    fill: "#8ABEAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLLetter);
export default __webpack_public_path__ + "static/media/l-letter.ce39ca191e1a189a0ff65d1237109939.svg";
export { ForwardRef as ReactComponent };